class MoneyFormat extends HTMLElement {
  connectedCallback() {
    const rawValue = this.textContent.trim();
    const cents = parseInt(rawValue, 10);
    if (isNaN(cents)) return;

    const currency = window.Shopify?.currency?.active || "USD";
    const locale = document.documentElement.lang || "en";
    const zeroDecimalCurrencies = ["JPY", "KRW", "VND"];

    const amount = zeroDecimalCurrencies.includes(currency)
      ? cents
      : cents / 100;

    let formatted = new Intl.NumberFormat(locale, {
      style: "currency",
      currency,
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    }).format(amount);

    formatted = formatted.replace(/\.00$/, "").replace(/,00$/, "");

    this.textContent = formatted;
  }
}

customElements.define("money-format", MoneyFormat);
